
export const truncateByLines = (lines = 1) => `
		overflow: hidden;
  		display: -webkit-box;
  		-webkit-box-orient: vertical;
  		-webkit-line-clamp: ${lines};
`;
